import React, {useState} from 'react';
import {createRoot} from 'react-dom/client';
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";

export function CsfPivotalInternalTestApiWidget(props) {

  const [loginName, setLoginName] = useState('');
  const [loginPassword, setLoginPassword] = useState('');

  const [loginSummary, setLoginSummary] = useState();

  const [listData, setListData] = useState();
  const [listConscentData, setListConscentData] = useState();
  const [listConformiteData, setListConformiteData] = useState();
  const [listDelegationsData, setListDelegationsData] = useState();
  const [listEmploymentPlacesData, setListEmploymentPlacesData] = useState();


  function handleSubmit(event) {
    event.preventDefault();

    const loginUrl = props.apiUrl + '/rest/accounts/actions/login';
    const postBody = {
      userName: loginName,
      password: loginPassword,
      scope: "full refresh_token"
    };

    const requestMetadata = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'pivotalEnvironmentName': props.apiEnv
      },
      body: JSON.stringify(postBody)
    };

    fetch(loginUrl, requestMetadata)
      .then(res => res.json())
      .then(data => {

        console.log(data);

        if (data.success !== true) {
          // error
          setLoginSummary("❌ Error during login, check console");
          return;
        }

        // login Ok
        setLoginSummary("✔ Login success!");

        // try fetching rest of data with api
        fetchAdditionalData(data.payload.access_token);


      }).catch(function (error) {
      console.log(error);
      setLoginSummary("❌ Error during login, check console");

    });

  }

  function fetchAdditionalData(apiToken) {
    let searchApi = new PivotalSearchApi(
      props.apiUrl,
      props.apiEnv,
      apiToken
    );

    try {
      let responsePromiseConscent = searchApi.callSearchEndpoint(
        {
          'ParameterValues': ["", ""],
          'maxRows': 25,
          'startRow': 1,
          'matchCondition': 1,
          'search': "CSF_CRC_Conscentement_REST"
        },
        PivotalSearchApi.PIVOTAL_ENV_SPLIT_BROKER
      );

      responsePromiseConscent
        .then(responseData => {

          console.log(responseData);

          if (responseData &&
            responseData.success &&
            responseData.payload &&
            responseData.payload.data &&
            responseData.payload.data.rows &&
            responseData.payload.data.rows.length >= 0) {

            setListConscentData("✔ Success for callSearchEndpoint:CSF_CRC_Conscentement_REST with " +
              responseData.payload.data.rows.length + " results in the requested page.");

          }
          else {
            setListConscentData("❌ No Success for callSearchEndpoint:CSF_CRC_Conscentement_REST");
          }

        })// rest of script
        .catch(function (error) {
          console.log(error);
          setListConscentData("❌ Error during handling of promise for callSearchEndpoint:CSF_CRC_Conscentement_REST, check console");
        });


      let responsePromiseConformite = searchApi.callSearchEndpoint(
        {
          'ParameterValues': ["", ""],
          'maxRows': 25,
          'startRow': 1,
          'matchCondition': 1,
          'search': "REDU_Conformite_QUERY_REST"
        },
        PivotalSearchApi.PIVOTAL_ENV_SPLIT_BROKER
      );

      responsePromiseConformite
        .then(responseData => {

          console.log(responseData);

          if (responseData &&
            responseData.success &&
            responseData.payload &&
            responseData.payload.data &&
            responseData.payload.data.rows &&
            responseData.payload.data.rows.length >= 0) {
            setListConformiteData("✔ Success for callSearchEndpoint:REDU_Conformite_QUERY_REST with " +
              responseData.payload.data.rows.length + " results in the requested page.");
          }
          else {
            setListConformiteData("❌ No Success for callSearchEndpoint:REDU_Conformite_QUERY_REST");
          }

        })// rest of script
        .catch(function (error) {
          console.log(error);
          setListConformiteData("❌ Error during handling of promise for callSearchEndpoint:REDU_Conformite_QUERY_REST, check console");
        });


      let responsePromiseDelegations = searchApi.callSearchEndpoint(
        {
          'ParameterValues': [""],
          'maxRows': 25,
          'startRow': 1,
          'matchCondition': 1,
          'search': "CSF_CRC_Manager_Delegat_REST"
        },
        PivotalSearchApi.PIVOTAL_ENV_SPLIT_BROKER
      );

      responsePromiseDelegations
        .then(responseData => {

          console.log(responseData);

          if (responseData &&
            responseData.success &&
            responseData.payload &&
            responseData.payload.data &&
            responseData.payload.data.rows &&
            responseData.payload.data.rows.length >= 0) {
            setListDelegationsData("✔ Success for callSearchEndpoint:CSF_CRC_Manager_Delegat_REST with " +
              responseData.payload.data.rows.length + " results in the requested page.");
          }
          else {
            setListDelegationsData("❌ No Success for callSearchEndpoint:CSF_CRC_Manager_Delegat_REST");
          }

        })// rest of script
        .catch(function (error) {
          console.log(error);
          setListDelegationsData("❌ Error during handling of promise for callSearchEndpoint:CSF_CRC_Manager_Delegat_REST, check console");
        });


      let responsePromiseEmploymentPlaces = searchApi.callSearchEndpoint(
        {
          'ParameterValues': [""],
          'maxRows': 25,
          'startRow': 1,
          'matchCondition': 1,
          'search': "CSF_CRC_Employment_Places_REST"
        },
        PivotalSearchApi.PIVOTAL_ENV_SPLIT_BROKER
      );

      responsePromiseEmploymentPlaces
        .then(responseData => {

          console.log(responseData);

          if (responseData &&
            responseData.success &&
            responseData.payload &&
            responseData.payload.data &&
            responseData.payload.data.rows &&
            responseData.payload.data.rows.length >= 0) {
            setListEmploymentPlacesData("✔ Success for callSearchEndpoint:CSF_CRC_Employment_Places_REST with " +
              responseData.payload.data.rows.length + " results in the requested page.");
          }
          else {
            setListEmploymentPlacesData("❌ No Success for callSearchEndpoint:CSF_CRC_Employment_Places_REST");
          }

        })// rest of script
        .catch(function (error) {
          console.log(error);
          setListEmploymentPlacesData("❌ Error during handling of promise for callSearchEndpoint:CSF_CRC_Employment_Places_REST, check console");
        });


    }
    catch (error) {
      console.log(error);
      setListData("❌ Error during call of APIs, check console.");
    }

  }


  return (

    <div>

      <div>
        {loginSummary}
      </div>

      <div>
        Username:
        <input autoCorrect="none" autoCapitalize="none" spellCheck="false"
               type="text"
               id="loginFormUsernameInput"
               name="loginFormUsernameInput"
               value={loginName}
               onChange={e => setLoginName(e.target.value)}
               size="15" maxLength="60"
               className="form-text required" required="required"
               aria-required="true"/>
      </div>

      <div>
        Password:
        <input data-drupal-selector="edit-pass" type="password"
               id="loginFormPasswordInput" name="loginFormPasswordInput"
               size="15" maxLength="128"
               value={loginPassword}
               onChange={e => setLoginPassword(e.target.value)}
               className="form-text required" required="required"
               aria-required="true"/>
      </div>

      <div>
        <button onClick={handleSubmit}>
          {window.Drupal.t('Log in')}
        </button>
      </div>


      <div>
        {listConscentData}
      </div>

      <div>
        {listConformiteData}
      </div>

      <div>
        {listDelegationsData}
      </div>

      <div>
        {listEmploymentPlacesData}
      </div>

      <div>
        {listData}
      </div>

    </div>
  );
}


window.addEventListener('DOMContentLoaded', () => {

  const domNode = document.getElementById('CsfPivotalInternalTestApiWidget');

  if (domNode !== null) {
    const root = createRoot(domNode);

    const apiUrl = domNode.getAttribute("data-api-url");
    const apiEnv = domNode.getAttribute("data-api-env");

    root.render(<CsfPivotalInternalTestApiWidget
      apiUrl={apiUrl}
      apiEnv={apiEnv}
    />);
  }
});
